module.exports = __webpack_public_path__ + "img/15.42b54371.jpg";